import React, { useMemo } from "react";

// Email HTML is untrusted. It is rendered in an iframe sandboxed without
// allow-scripts/allow-same-origin/allow-forms, so it can neither run code nor reach
// the app's origin; the CSP additionally blocks remote resources (tracking pixels)
// unless the user opts in.
const buildDocument = (html, allowRemote) => {
  const remote = allowRemote ? " https: http:" : "";
  const csp = `default-src 'none'; img-src data: blob:${remote}; style-src 'unsafe-inline'${remote}; font-src data:${remote}; media-src data:${remote}`;
  return `<!DOCTYPE html><html><head><meta charset="utf-8">
<meta http-equiv="Content-Security-Policy" content="${csp}">
<base target="_blank">
<style>
  body { margin: 0; padding: 16px; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif; font-size: 14px; line-height: 1.5; color: #1f1f1f; word-wrap: break-word; overflow-wrap: anywhere; }
  img { max-width: 100%; height: auto; }
  pre { white-space: pre-wrap; }
  blockquote { margin: 0 0 0 8px; padding-left: 12px; border-left: 3px solid #d9d9d9; color: #555; }
  table { max-width: 100%; }
</style></head><body>${html || ""}</body></html>`;
};

const MessageBody = ({ html, allowRemote = false, style }) => {
  const srcDoc = useMemo(() => buildDocument(html, allowRemote), [html, allowRemote]);
  return (
    <iframe
      title="message-body"
      className="mail-body-frame"
      sandbox="allow-popups allow-popups-to-escape-sandbox"
      referrerPolicy="no-referrer"
      srcDoc={srcDoc}
      style={style}
    />
  );
};

export default MessageBody;
